import type { EditorState } from "prosemirror-state";

export default function getLinkRange(state: EditorState) {
  const { $from, empty } = state.selection;
  if (!empty) return null;

  const linkType = state.schema.marks.link;
  const parent = $from.parent;
  const parentStart = $from.start();

  let index = $from.index();

  if (index >= parent.childCount) {
    index = parent.childCount - 1;
    if (index < 0) return null;
  }

  const node = parent.child(index);

  if (!(node?.isText && linkType.isInSet(node.marks))) {
    return null;
  }

  const linkMark = node.marks.find((m) => m.type === linkType);
  if (!linkMark) return null;

  let startIndex = index;
  while (startIndex > 0) {
    const prevNode = parent.child(startIndex - 1);
    if (!prevNode.isText || !linkType.isInSet(prevNode.marks)) break;
    startIndex--;
  }

  let endIndex = index;
  while (endIndex < parent.childCount - 1) {
    const nextNode = parent.child(endIndex + 1);
    if (!nextNode.isText || !linkType.isInSet(nextNode.marks)) break;
    endIndex++;
  }

  let from = parentStart;
  for (let i = 0; i < startIndex; i++) {
    from += parent.child(i).nodeSize;
  }

  let to = from;
  for (let i = startIndex; i <= endIndex; i++) {
    to += parent.child(i).nodeSize;
  }

  return {
    from,
    to,
    href: linkMark.attrs.href,
  };
}
